import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import places from 'places.js';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';

import config from '../../config';
import { getAccountDetails } from '../../store/selectors/account';
import { useModal } from '../../utils/modal';
import CustomAdressModal from '../../components/account/CustomAdressModal';
import { useErrorToaster } from '../../utils/errorToaster';
import { updateUserCustomAdress } from '../../store/actions/account';

function AddressInput({
  required = false,
  label = '',
  placeholder = '',
  onChange,
  disabled,
  handleLockButtonSuggestionsPicked,
  handleCustomAdressPicked,
  value = '',
  name = '',
  error = false,
  helperText = null
}) {
  const dispatch = useDispatch();
  const accountDetails = useSelector(getAccountDetails);
  const { t } = useTranslation(['account']);
  const [inputValue, setInputValue] = useState(value);
  const [suggestions, setSuggestions] = useState(0);
  const [suggestionsPicked, setSuggestionsPicked] = useState(true);
  const [customSuggestionsPicked, setCustomSuggestionsPicked] = useState(false);
  const customAdressModal = useModal();
  const displayError = useErrorToaster();
  const { enqueueSnackbar } = useSnackbar();

  const customInitialValues = {
    address_line1: accountDetails.addressLine1
      ? accountDetails.addressLine1
      : '',
    address_line2: accountDetails.addressLine2
      ? accountDetails.addressLine2
      : '',
    address_postal_code: accountDetails.address_postal_code
      ? accountDetails.address_postal_code
      : '',
    address_locality: accountDetails.address_locality
      ? accountDetails.address_locality
      : '',
    address_state: accountDetails.address_state
      ? accountDetails.address_state
      : '',
    address_country: accountDetails.address_country
      ? accountDetails.address_country
      : ''
  };

  const handleAddress = address => {
    setInputValue(address);

    if (typeof onChange === 'function') {
      onChange(address);
    }
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleCustomAddress = async address => {
    try {
      await dispatch(updateUserCustomAdress(address));
      enqueueSnackbar(t('account:profil-changed'), { variant: 'success' });
    } catch (error) {
      displayError(error);
    }
    if (typeof handleCustomAdressPicked === 'function') {
      handleCustomAdressPicked(true);
    }
    handleLockButtonSuggestionsPicked(true);
    setCustomSuggestionsPicked(true);
    setSuggestionsPicked(true);
    customAdressModal.close();
  };

  const onBlur = e => {
    if (suggestions.length === 0 || inputValue === '') {
      setSuggestionsPicked(false);
    }
    if (inputValue === '') {
      handleLockButtonSuggestionsPicked(false);
    }
  };

  useEffect(() => {
    const placesAutocomplete = places({
      appId: config.algolia.appId,
      apiKey: config.algolia.apiKey,
      container: document.querySelector('#address-input')
    }).configure({
      language: 'fr',
      type: 'address'
    });

    placesAutocomplete.on('locate', e => {});

    placesAutocomplete.on('suggestions', e => {
      setSuggestionsPicked(false);
      handleLockButtonSuggestionsPicked(false);
    });

    placesAutocomplete.on('change', e => {
      setSuggestionsPicked(true);
      handleLockButtonSuggestionsPicked(true);
      handleAddress(e.suggestion.value);
    });

    placesAutocomplete.on('clear', () => {
      handleAddress('');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickDisabledInput = e => {
    if (
      typeof handleCustomAdressPicked === 'function' &&
      customSuggestionsPicked
    ) {
      customAdressModal.open();
    }
  };

  return (
    <FormControl fullWidth className="address-input-control">
      <TextField
        variant="outlined"
        onBlur={e => onBlur(e)}
        required={required}
        label={label}
        id="address-input"
        name={name}
        disabled={true}
        type="text"
        value={inputValue}
        onChange={e => handleAddress(e.target.value)}
        onClick={e => onClickDisabledInput(e)}
        placeholder={placeholder}
        error={!!error || !suggestionsPicked}
      />
      {error && helperText ? (
        <FormHelperText error={true}>{helperText}</FormHelperText>
      ) : null}
      {!suggestionsPicked ? (
        <FormHelperText error={true}>
          {t('account:pick-address')}
        </FormHelperText>
      ) : null}

      <p className="edit-adress">
        {t('account:pick-custom-address')}{' '}
        <span
          className="click"
          onClick={customAdressModal.open && customAdressModal.open}
        >
          {t('account:click-custom-address')}
        </span>{' '}
      </p>

      <CustomAdressModal
        open={customAdressModal.isOpen}
        onClose={customAdressModal.close}
        handleCustomAddress={handleCustomAddress}
        initialValues={customInitialValues}
      />
    </FormControl>
  );
}

export default AddressInput;
